/*import { createReducer } from 'redux-act'

const DEFAULT_STATE = {
  reducer: reducer
}*/

import { reducer } from 'react-redux-toastr';
export default reducer;
